module.exports = __webpack_public_path__ + "static/images/containers/BuildingsCarousel/images/bg-hover.b7a49d5f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingsCarousel/images/bg-hover.png
// module id = 2808
// module chunks = 11